import DecimalDegreeGrid from './DecimalDegreeGrid';
import DMSGrid from './DMSGrid';
import UTMGrid from './UTMGrid';
import MGRSGrid from './MGRSGrid';

const gridGenerators = {
    'lng|lat|dd': DecimalDegreeGrid,
    'lng|lat|dms': DMSGrid,
    mgrs: MGRSGrid,
    none: () => undefined,
    utm: UTMGrid,
};

export default function getGridMapboxStyle(
    grid: Grid,
    bounds: mapboxgl.LngLatBounds | undefined,
    zoom: number | undefined
): mapboxgl.Style | undefined {
    if (bounds && zoom && gridGenerators[grid]) {
        return gridGenerators[grid](bounds, zoom);
    } else {
        return undefined;
    }
}
